import {
    useClientTips
} from "@twigsby/client-data";
import {
    Button,
    ButtonSize,
    ColourOutline,
    ContentBlock,
    ContentLoader,
    useTranslation
} from "@twigsby/frontend-framework";
import {useUKPBAuth} from "../../Providers/AuthProvider";
import Carousel from "../Carousel";

type MapTipsType = {
    title?: string;
}

const MapTips = (props: MapTipsType) => {
    const { t } = useTranslation();
    const { data, status, error } = useClientTips();

    return (
        <>
            {status === 'loading' ? (
                <ContentLoader rounded={true} childHeight={'15em'} childCount={1} />
            ) : status === "error" ? (
                <ContentBlock error={true} stacked={true} title={error.name} content={error.message} />
            ) : (
                <Carousel
                    isOpen={true}
                    title={props.title || t('labels.tips')}
                    items={data.sort(() => Math.random() - 0.5).map((item, index) =>
                        <div className={'p-md'} key={`tipItem${index}`}>
                            <h6 className={'mb-xs'}>{item.metadata['Title']}</h6>
                            <p>{item.metadata.Body}</p>
                            {item?.metadata.Link && item?.metadata.LinkText && (
                                <div className={'mt-sm'}>
                                    <Button
                                        title={item.metadata.LinkText}
                                        size={ButtonSize.Small}
                                        colour={ColourOutline.Secondary}
                                        squared={true}
                                        actionLink={{ title: item.metadata.LinkText, url: item.metadata.Link, target: '_blank', rel: 'noopener noreferrer' }}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                />
            )}
        </>
    )
}

const TipBlock = (props: MapTipsType) => {
    const { token } = useUKPBAuth();

    return (
        <>
            {token && (
                <MapTips {...props} />
            )}
        </>
    )
}

export default TipBlock
